// Tipos do Painel Financeiro Executivo. Ver docs/PLAN-painel-financeiro-executivo.md
// (seção 3) para a origem de cada campo e a regra de derivação de status.

// FaturaPainelRaw/FaturaPainel/Kpis/FaixaAging agora vivem em
// src/lib/financeiro/types.ts (compartilhados com o Painel Executivo geral,
// ver docs/superpowers/specs/2026-08-21-painel-executivo-design.md).
// Reexportados aqui para não mexer nos ~20 imports existentes desta tela.
export type { StatusBoleto, FaturaPainelRaw, FaturaPainel, Kpis, FaixaAging, PontoMensal, DevedorTop } from '../../../src/lib/financeiro/types';
import type { FaturaPainel } from '../../../src/lib/financeiro/types';
import type { StatusBoleto } from '../../../src/lib/statusBoleto';

export type PeriodoFiltro =
  | 'ultimos12' | 'ultimos6' | 'ultimos3'
  | 'mesAtual' | 'mesAnterior'
  | 'trimestreAtual' | 'trimestreAnterior'
  | 'anoAtual' | 'anoAnterior'
  | 'historico';

export interface FiltrosPainel {
  periodo: PeriodoFiltro;
  unidadeGeradora: string; // 'todas' | 'outras' | nome exato da UG
  status: 'todos' | StatusBoleto;
  clienteBusca: string;
}

export const FILTROS_INICIAIS: FiltrosPainel = {
  // 'historico' e não 'ultimos12' (default original da spec): inadimplência é
  // estoque, não fluxo — boleto de AGO/2025 ainda não pago continua sendo
  // dívida hoje. Com 12 meses o painel escondia R$ 2.764,43 que a Central
  // Executiva de Inadimplência mostrava, e os dois números não fechavam.
  // Decisão da Meryene em 12/08/2026 (chamado #3789).
  periodo: 'historico',
  unidadeGeradora: 'todas',
  status: 'todos',
  clienteBusca: '',
};

export interface CardComparativo {
  titulo: string;
  metricaDescricao: string;
  rotuloAtual: string;
  rotuloAnterior: string;
  valorAtual: number;
  valorAnterior: number;
  diferencaAbsoluta: number;
  diferencaPercentual: number | null; // null quando anterior = 0
  corSemantica: 'positiva' | 'negativa' | 'neutra';
  extra?: string; // ex.: "370 clientes", "ticket médio R$ 792,00" — combinado dos dois períodos
  formato?: 'moeda' | 'numero' | 'percentual'; // como renderizar valorAtual/valorAnterior/diferencaAbsoluta; ausente = tratar como moeda (cards antigos)
  detalheMensal?: { mesReferencia: string; periodo: 'A' | 'B'; valor: number }[]; // quebra mês a mês, ordem A-depois-B; ausente = sem quebra mensal (cards antigos)
  extraAtual?: string; // mesma info de `extra`, só do período A — pra legenda sob o grupo de barras do período A
  extraAnterior?: string; // idem, só do período B
}

export interface Insight {
  tipo: 'alerta' | 'positivo' | 'atencao';
  mensagem: string;
}
